/** 落地页共用常量与 mock 数据（来自印迹设计稿 1451308） */
/** TODO: 若后续接 CMS/运营配置，再替换为真实接口 */

export const CDN = 'https://s3plus.sankuai.com/human-platform-video'
export const CONTACT_EMAIL = 'it_mlive@meituan.com'

/** 落地页灵犀 bid（MV 的 type/duration 由 reportMv 统一附加） */
export const LX_BIDS = {
  // 导航栏
  navMv: 'b_mtlive_b_lpwd2d0e_mv',
  navMc: 'b_mtlive_b_lpwd2d0e_mc',
  // 首屏
  heroMv: 'b_mtlive_b_no15mnao_mv',
  heroMc: 'b_mtlive_b_no15mnao_mc',
  // 产品介绍
  capabilityMv: 'b_mtlive_b_lxibioyj_mv',
  // 产品介绍视频
  ctaMv: 'b_mtlive_b_n1mq8g8w_mv',
  ctaMc: 'b_mtlive_b_n1mq8g8w_mc',
  // 开播步骤 
  stepMv: 'b_mtlive_b_dtryfn2g_mv',
  // 产品优势
  whyMliveMv: 'b_mtlive_b_cpn2lh4q_mv',
  // 技术介绍
  techMv: 'b_mtlive_b_5hitjgky_mv',
  // 商家案例
  caseMv: 'b_mtlive_b_xec795b9_mv',
  caseMc: 'b_mtlive_b_xec795b9_mc',
  // 常见问题
  faqMv: 'b_mtlive_b_gruzm8cy_mv',
  faqMc: 'b_mtlive_b_gruzm8cy_mc',
  // 底部导航栏
  footerMv: 'b_mtlive_b_3qbwaz8q_mv',
  footerMc: 'b_mtlive_b_3qbwaz8q_mc'
} as const

/** 图标网格流动区资源名（拼到 CDN 下） */
export const MARQUEE_ICONS = [
  'icon.svg',
  'icon-2.svg',
  'icon-3.svg',
  'icon-4.svg',
  'video.svg',
  'square-stack-up-fill.svg',
  'sticker.svg',
  'text.svg',
  '630.svg',
  '46.svg',
  '98.svg',
  '23.svg'
] as const

export const NAV_LINKS = [
  { label: '产品能力', href: '#capSection' },
  { label: '产品优势', href: '#whyDigitalHumanSection' },
  { label: '商家案例', href: '#caseSection' },
  { label: '开播流程', href: '#stepSection' },
  { label: '核心技术', href: '#techSection' },
  { label: '常见问题', href: '#faqSection' }
] as const

export interface CapabilityItem {
  title: string
  subtitle: string
  description: string
  video: string
  poster: string
}

export const CAPABILITIES: CapabilityItem[] = [
  {
    title: '势在形中',
    subtitle: '海量形象+AI装修   自动生成专属直播间',
    description:
      '从形象到场景，让每一个直播间都具备销售力。海量数字人形象自由选配，AI 一键智能装修自动匹配门店风格，快速生成直播素材，开播即用。',
    video: `${CDN}/${encodeURIComponent('势在形中')}.mp4`,
    poster: 'https://p0.meituan.net/mlive/4fd94dc1523e5b2f48ff42d785b4143331608.jpg'
  },
  {
    title: '言之有物',
    subtitle: 'AI生成讲解脚本   智能合成自然语音',
    description:
      'AI深度理解商品、门店和优惠，自动生成结构化高吸引力讲解脚本。TTS智能合成自然流畅的主播声音，高燃带货，状态24小时在线。',
    video: `${CDN}/${encodeURIComponent('言之有物')}.mp4`,
    poster: 'https://p0.meituan.net/mlive/7d31c1d28161bb87b1dfdca51c457cf749479.jpg'
  },
  {
    title: '一呼即应',
    subtitle: 'AI智能问答   深度理解商品与顾客',
    description:
      '把每一次互动都变成经营机会。AI精准识别顾客提问意图，结合商品信息与优惠策略智能应答，评论区文字与语音播报同步触达，边聊边促成交。',
    video: `${CDN}/${encodeURIComponent('一呼即应')}.mp4`,
    poster: 'https://p0.meituan.net/mlive/adc44b098cc7ec7ac9779b24f633a61326861.jpg'
  },
  {
    title: '声动其时',
    subtitle: 'AI助播   智能感知营销节点',
    description:
      '实时感知每一刻，每一个进间、每一次下单，AI都在第一时间响应。实时感知，主动出击，让互动成为商机。',
    video: `${CDN}/${encodeURIComponent('声动其时')}.mp4`,
    poster: 'https://p0.meituan.net/mlive/993db7708db7901ed02db7ccb31d2a3a36334.jpg'
  }
]

export const WHY_DIGITAL_HUMAN = [
  {
    title: '3分钟快速开播',
    description: '无需搭建直播影棚，无需招募主播，无需专业硬件，3分钟快速开播',
    className: 'card-1'
  },
  {
    title: '7x24小时在线',
    description: '全天持续讲解互动，抢占闲时流量，覆盖更多经营时段',
    className: 'card-2'
  },
  {
    title: '问答更及时更全面',
    description: '商品、门店与优惠信息智能应答，秒级回复，减少等待，有效促成交',
    className: 'card-3'
  },
  {
    title: '好品质高调性',
    description: '高品质数字人形象、装修模板，搭配AI装修能力，稳定呈现门店品牌调性',
    className: 'card-4'
  },
  {
    title: '卖点讲解更丰富',
    description: 'AI主播智能调用海量信息，挖掘多维商品卖点，让讲解更全面更丰富',
    className: 'card-5'
  }
] as const

export const WHY_MLIVE = [
  {
    title: '更懂本地生活',
    description: '针对到餐、服务零售、酒旅等场景专项优化，更贴近本地商家的实际经营需求。',
    className: 'mlive-1'
  },
  {
    title: '商品理解更深入',
    description: '依托美团丰富的商品、套餐、门店和优惠信息，准确提炼卖点，让讲解和回复更具吸引力。',
    className: 'mlive-2'
  },
  {
    title: '官方运营支持',
    description: '提供开播指导和问题支持，帮助商家更顺畅地开展数字人直播，降低运营门槛。',
    className: 'mlive-3'
  },
  {
    title: '平台协同更高效',
    description: '与美团直播系统深度协同，覆盖开播、商品配置、货架调整和经营复盘等关键环节。',
    className: 'mlive-4'
  },
  {
    title: '更多公域曝光机会',
    description: '优质数字人直播间有机会获得平台公域曝光支持，帮助商家触达更多潜在顾客。',
    className: 'mlive-5'
  }
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: '美团官方数字人开播需要收费吗？',
    answer:
      '美团智播提供不同层级的解决方案，可满足您的多样化需求，具体的费用标准和计费模式请联系与您对接的销售同学。'
  },
  {
    question: '用数字人直播是否会被限流？',
    answer: '在美团平台使用官方数字人直播不会被限流，优质数字人直播间还有机会获得平台公域曝光支持。'
  },
  {
    question: '是否支持定制主播形象？',
    answer: '支持根据商家品牌调性定制专属数字人形象，具体定制流程请联系对接的销售同学咨询。'
  },
  {
    question: '数字人直播间能体现门店特色吗？',
    answer: '支持 AI 一键智能装修，自动匹配门店风格，快速生成具有门店特色的直播间背景与素材。'
  },
  {
    question: '数字人主播能自动回复用户提问吗？',
    answer: '美团智播配备智能问答能力，可根据用户提问，自动调用门店及商品信息进行实时回复，评论区文字与语音播报同步触达。'
  }
]

export interface CaseItem {
  id: number
  /** 埋点 video_name */
  name: string
  /** 默认蒙层居中封面图，hover 播视频时随蒙层隐藏 */
  cover: string
  /** 静态视频首帧，避免部分安卓 WebView 无法预解码暂停视频。 */
  poster: string
  video: string
  /** 移动端更小体积片源 */
  videoMobile: string
}

/** 直播间案例视频；桌面端原片，移动端用「更小版」加速加载 */
export const CASE_VIDEOS: CaseItem[] = [
  {
    id: 1,
    name: '喵大叔',
    cover: 'https://p0.meituan.net/mliveimage/5bced77c9f69bad68c4c796d0b126cc53645.png',
    poster: 'https://p1.meituan.net/mlive/ee7a371f92f8f7a5088b1657fa175ea2159630.jpg',
    video: `${CDN}/${encodeURIComponent('喵大叔直播间')}.mp4`,
    videoMobile: `${CDN}/${encodeURIComponent('喵大叔_更小版')}.mp4`
  },
  {
    id: 2,
    name: '瑞力健身',
    cover: 'https://p0.meituan.net/mliveimage/671d2902fb3d20771068a6871787111f3096.png',
    poster: 'https://p1.meituan.net/mlive/5a829322d1459dff36b167db6767384a203504.jpg',
    video: `${CDN}/${encodeURIComponent('瑞力健身视频')}.mp4`,
    videoMobile: `${CDN}/${encodeURIComponent('瑞力健身_更小版')}.mp4`
  },
  {
    id: 3,
    name: '猫咖',
    cover: 'https://p1.meituan.net/mliveimage/57870cb31edaec49b56f9326d5cde9233106.png',
    poster: 'https://p0.meituan.net/mlive/532277fecbd8f0ff101581b29109c061129586.jpg',
    video: `${CDN}/AIGC${encodeURIComponent('数字人')}.mp4`,
    videoMobile: `${CDN}/${encodeURIComponent('猫咖萌宠_更小版')}.mp4`
  },
  {
    id: 4,
    name: '佛山美食',
    cover: 'https://p0.meituan.net/mliveimage/7a7bdd51ff5b1092765cfbc440ff88433464.png',
    poster: 'https://p1.meituan.net/mlive/350620d45d023ac9bb583eac6a132d1d236950.jpg',
    video: `${CDN}/${encodeURIComponent('官网案例1')}.mp4`,
    videoMobile: `${CDN}/${encodeURIComponent('佛山美食_更小版')}.mp4`
  },
  {
    id: 5,
    name: '湖北味觉联盟',
    cover: 'https://p0.meituan.net/mliveimage/affbf2f97d556c91d22b10f8ee822e773583.png',
    poster: 'https://p0.meituan.net/mlive/762b863691a7e28228fe617bbd128a70173196.jpg',
    video: `${CDN}/${encodeURIComponent('官网案例2')}.mp4`,
    videoMobile: `${CDN}/${encodeURIComponent('湖北味觉_更小版')}.mp4`
  },
  {
    id: 6,
    name: '特价酒店',
    cover: 'https://p0.meituan.net/mliveimage/62a7e83707de1a169ec43c20f762fa723059.png',
    poster: 'https://p0.meituan.net/mlive/f288b66d26c8f5bf2b7cb05de536e1fb214912.jpg',
    video: `${CDN}/${encodeURIComponent('官网视频3')}.mp4`,
    videoMobile: `${CDN}/${encodeURIComponent('特价酒店直播_更小版')}.mp4`
  }
]

export const FOOTER_PRODUCT_LINKS = [
  { label: '产品优势', href: '#whyDigitalHumanSection' },
  { label: '商家案例', href: '#caseSection' },
  { label: '开播流程', href: '#stepSection' },
  { label: '核心技术', href: '#techSection' },
  { label: '常见问题', href: '#faqSection' }
] as const

export const FOOTER_SOCIALS = [
  {
    label: '微信公众号',
    icon: 'https://p1.meituan.net/mliveimage/8fcbd928625b7d7bf3883fae5a339a9b1201.png',
    qr: 'https://p0.meituan.net/smartvenus/f48f2015b1db8761881b1cba9cffc65727864.png.webp'
  },
  {
    label: '微信视频号',
    icon: 'https://p0.meituan.net/mliveimage/6fee21392718b84835eca5206b9ed4b71233.png',
    qr: 'https://p0.meituan.net/smartvenus/37896028189d9ff8917138645e335bc939640.png.webp'
  },
  {
    label: '微博',
    icon: 'https://p0.meituan.net/mliveimage/26c4426b4ef7e2d39d881a3abade6ce11355.png',
    qr: 'https://p0.meituan.net/smartvenus/9350a781f47882c462aeb21f397f201527046.png.webp'
  }
] as const

export interface StepItem {
  num: string
  name: string
  subtitle: string
  image: string
}

export const STEPS: StepItem[] = [
  {
    num: '开播第一步',
    name: '选商品',
    subtitle: '选定商品，即可自动生成高吸引力讲解词，同步支持卖点编辑',
    image: 'https://p0.meituan.net/mliveimage/d29da5226680d086fb5c003986af5978332660.png'
  },
  {
    num: '开播第二步',
    name: '配装修',
    subtitle: '海量数字人形象库中任意挑选，直播间背景装修一步到位',
    image: 'https://p0.meituan.net/mliveimage/9fbb7941bfa9cfbce0f66954dbdea7cb1181837.png'
  },
  {
    num: '开播第三步',
    name: '自动开播',
    subtitle: '合成完成后7×24全天候，关掉电脑也不停，边聊边卖不漏单',
    image: 'https://p1.meituan.net/mliveimage/f0ee1904f81f33397e71a39ecb97983e1171786.png'
  }
]

export const ASSETS = {
  logo: `${CDN}/logo.webp`,
  cursor: `${CDN}/cursor.webp`,
  btnArrow: `${CDN}/btn-arrow.png`,
  heroVideo: `${CDN}/crystal-orb.webm`,
  /** 桌面 Safari：HEVC + Alpha，原生透明无需抠图 */
  heroVideoSafari: `${CDN}/crystal-orb-loop-hevc-alpha.mov`,
  /** 移动端/微信：S3 上的轻量 MP4 */
  heroVideoMobile: 'https://s3plus.sankuai.com/human-platform-video/webfirst.mp4',
  heroPoster: 'https://p1.meituan.net/mlive/51fcffd5c9073632ec8dd62c16c24bda507516.png',
  xhsQr: 'https://p0.meituan.net/mliveimage/daccc3830e05b7db5658e7df07fd3f5f29160.png',
  ctaPoster: 'https://p0.meituan.net/mlive/e20f7ff4ea08f595fde32c25442afae614939.jpg',
  ctaVideo: `${CDN}/${encodeURIComponent('数字人互联网宣终稿small')}.mp4`,
  /** 移动端：约 9MB 宣片，便于弱网加载 */
  ctaVideoMobile: `${CDN}/${encodeURIComponent('数字人互联网宣终稿9MB')}.mp4`,
  patentOrnamentLeft: 'https://p0.meituan.net/mlive/f8ea681eab44c5f3c66f5f69e484e9ab6118.png',
  patentOrnamentRight: 'https://p0.meituan.net/mlive/72c44ad5575ac9174a6ef89ec6a7cd566157.png',
  patentRibbon: 'https://p0.meituan.net/mliveimage/bbd62a62d53177c427244d25fb2494ed780108.png',
  patentMedal: 'https://p0.meituan.net/mliveimage/47d3fa1c0a2fd344ae7a0aa0611f90fa509392.png',
  whyMliveMediaMid: 'https://p0.meituan.net/mliveimage/206a3fb4d63a7372235f596f5f38c46382791.png',
  whyMliveMediaBottom: 'https://p0.meituan.net/mliveimage/11c0d183070ed5a1c5cc9c693984cbb6248614.png',
  whyMliveMediaProduct: 'https://p0.meituan.net/mliveimage/a1ce121377b1c736b22130577aaf7701163225.png',
  whyMliveMediaTop: 'https://p0.meituan.net/mliveimage/51a25efb97874870459bacf26158a8ae114138.png'
} as const
